/* eslint-disable react-hooks/exhaustive-deps */
import { Form, Row, Select } from 'antd'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { companySizes } from 'src/core/helpers/companies'
import { PersonalDetails, rolType } from 'src/core/models'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import {
  setUserCountry,
  authRolSelector,
  setRegisterStep,
  countryListSelector,
  setPersonalDetails,
  personalDetailsRegisterSelector,
} from 'src/features'
import {
  CountrySelectForRegister,
  RegisterUserStepChanger,
  CustomTextInput,
  CustomSelect,
  CustomTitle,
  CustomText,
  CustomCard,
  CustomCol,
} from 'src/components'

const PersonalDetailsFormRegister: React.FC = () => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const dispatch = useAppDispatch()
  const { country } = useRouter().query
  const rol: rolType = useAppSelector(authRolSelector)
  const personalDetails: PersonalDetails = useAppSelector(personalDetailsRegisterSelector)
  const countryList = useAppSelector(countryListSelector)

  const onFinish = (values: PersonalDetails) => {
    dispatch(setPersonalDetails(values))
    dispatch(setRegisterStep(4))
  }

  useEffect(() => {
    form.setFieldsValue({
      ['firstName']: personalDetails.firstName,
      ['lastName']: personalDetails.lastName,
      ['phone']: personalDetails.phone,
      ['companyName']: personalDetails.companyName,
      ['companySize']: personalDetails.companySize,
      ['country']: personalDetails.country
    })
  }, [personalDetails])


  useEffect(() => {
    if (country) {
      if (countryList?.length > 0) {
        const countryId = countryList.find((c) => c?.code2 === String(country))?.id
        const newValue = countryId ? countryId : null
        dispatch(setUserCountry(newValue))
      }
    }
  }, [country])

  return (
    <div className='m-1'>
      <Form
        name='credentialsForm'
        onFinish={onFinish}
        autoComplete='off'
        className='mt-3'
        form={form}
      >
        <CustomCard>
          <CustomTitle label={t('settings.personalDetails')} type={null} />
          <Row>
            {/* First Name */}
            <CustomCol lg={24}>
              <CustomTitle label={t('admin.Brokerage.FirstName')} />
              <CustomTextInput
                name={'firstName'}
                placeholder={t('admin.Brokerage.FirstNamePlaceHolder')}
                required
              />
            </CustomCol>
          </Row>

          <Row>
            <CustomCol lg={24}>
              {/* last Name */}
              <CustomTitle label={t('admin.Brokerage.LastName')} />
              <CustomTextInput
                name={'lastName'}
                placeholder={t('admin.Brokerage.LastNamePlaceHolder')}
                required
              />
            </CustomCol>
          </Row>

          <Row>
            <CustomCol lg={24}>
              {/* Phone */}
              <CustomTitle label={t('admin.Brokerage.Phone')} />
              <CustomText label={t('Auth.Register.PhoneLabel')} type='secondary' />

              <CustomTextInput
                name={'phone'}
                placeholder={t('admin.Brokerage.PhonePlaceHolder')}
              />
            </CustomCol>
          </Row>

          {rol === 'COMPANY' && <Row>
            <CustomCol lg={24}>
              <CustomTitle label={t('admin.Brokerage.CompanyName')} />
              <CustomText label={t('Auth.Register.CompanyLabelName')} type='secondary' />

              <CustomTextInput
                name={'companyName'}
                placeholder={t('admin.Brokerage.CompanyNamePlaceholder')}
                required
              />
            </CustomCol>
          </Row>}

          {rol === 'COMPANY' && <Row>
            <CustomCol lg={24}>
              <CustomTitle label={t('admin.Brokerage.CompanySize')} />
              <CustomSelect
                name={'companySize'}
                placeholder={t('admin.Brokerage.CompanySizePlaceholder')}
                required
              >
                {companySizes?.map((item, idx) => (
                  <Select.Option value={item.value} key={idx}>{t('settings.' + item.label)}</Select.Option>
                ))}
              </CustomSelect>
            </CustomCol>
          </Row>}

          <CountrySelectForRegister loading={false} showLabel={true}/>
        </CustomCard>
        <RegisterUserStepChanger nextStepValue={4} beforeStepValue={2} />
      </Form>
    </div>
  )
}

export default PersonalDetailsFormRegister
